import React from "react"
import expertontheway_collab from "../../assets/images/products/collab/expert_on_the_way_collab.svg"
import expertontheway_mail from "../../assets/images/products/mail/expert_on_the_way_mail.svg"
import expertontheway_meet from "../../assets/images/products/meet/expert_on_the_way_meet.svg"
import expertontheway_identity from "../../assets/images/products/identity/expert_on_the_way_identity.svg"

import { ProductType } from "./ProductList"
import {
  getProductClass,
  getProductNutshellDescription,
} from "./KeyFeaturesList"
import {
  Link,
  Trans,
  useI18next,
  useTranslation,
} from "../../plugins/i18next/ea-react-i18next"
import Button, { ButtonType } from "../Start/Button"

const ProductDefeatChaos: React.FC<{ product: ProductType }> = ({
  product,
}) => {
  const { t } = useTranslation("components", {
    keyPrefix: "products.productDefeatChaos",
  })
  const { i18n } = useI18next()
  const currentLanguage = i18n.language

  const productClass = getProductClass(product)

  const expertontheway = (product: any): string => {
    switch (product) {
      case ProductType.Collab:
        return expertontheway_collab
      case ProductType.Mail:
        return expertontheway_mail
      case ProductType.Meet:
        return expertontheway_meet
      case ProductType.Identity:
        return expertontheway_identity
      default:
        return ""
    }
  }

  return (
    <div className="subscribe-area ptb-70 defeat-chaos-color">
      <div className="container-fluid hero-container">
        <div className="row align-items-center">
          {productClass !== "identity" ? (
            <>
              <div className="col-lg-6 col-md-12">
                <div className="subscribe-image">
                  <img
                    src={expertontheway(product)}
                    alt="subscribe"
                    className="product-monster-image"
                  />
                </div>
              </div>
              <div className="col-lg-6 col-md-12">
                <div className="subscribe-content">
                  <h2>{t(`${productClass}.title`)}</h2>
                  <p>{t(`${productClass}.description`)}</p>
                </div>
                <div className="defeat-chaos-footer">
                  <Button text={t("talkToExpert")} external={true} href={`https://calendly.com/easylife-365-demos-${currentLanguage}`} />
                  <Button text={t("viewPricing")} href="pricing" icon="flaticon-right" type={ButtonType.Secondary} />
                </div>
              </div>
            </>
          ) : (
            <>
              <div className="col-lg-6 col-md-12">
                <div className="subscribe-content">
                  <h2>{t(`${productClass}.title`)}</h2>
                  <p>{t(`${productClass}.description`)}</p>
                </div>
                <div className="defeat-chaos-footer-left">
                  <Button text={t("talkToExpert" as string)} external={true} href={`https://calendly.com/easylife-365-demos-${currentLanguage}`} />
                  <Link className="secondary-btn" to="/pricing">
                    {<i className="flaticon-right"></i>}
                    <strong> {t("viewPricing")}</strong>
                  </Link>
                </div>
              </div>
              <div className="col-lg-6 col-md-12">
                <div className="subscribe-image">
                  <img
                    src={expertontheway(product)}
                    alt="subscribe"
                    className="product-monster-image"
                  />
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  )
}

export default ProductDefeatChaos
